import React, { useState, useEffect } from 'react'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { Feedback } from 'component'
import util from 'meinian-package/src/utils/util'
import { Icon } from 'meinian-package/src/component'
import styles from './index.module.less'

const BOTTOM_TABS = [
  {
    title: '回收站',
    icon: 'm-huishouzhan',
    router: '/home/recycle',
    navigate: true
  },
  {
    title: '帮助中心',
    icon: 'm-bangzhuzhongxin',
    router: '/meinian/document',
    code: 6400007,
  },
  {
    title: '联系我们',
    icon: 'm-lianxiwomen',
    code: 6400006,
  }
]

export default () => {
  const navigate = useNavigate()
  const [activeKey, setActiveKey] = useState(null)
  const [feedbackVisible, setFeedbackVisible] = useState(false)

  useEffect(() => {
    if (location.pathname === '/meinian/home/recycle') {
      setActiveKey(0)
    } else {
      setActiveKey(null)
    }
  }, [location.pathname])

  return <div className={styles.asideFooter}>
    <div className="item-content">
      {BOTTOM_TABS.map((item, index) => {
        return <Tooltip
          placement="right"
          title={item.title}
        >
          <div
            key={item.title}
            className={classNames('item', { active: activeKey === index })}
            onClick={() => {
              if (item?.router) {
                if (item?.navigate) {
                  navigate(item.router)
                } else {
                  window.open(item.router)
                }
              } else {
                setFeedbackVisible(true)
              }
              util.track('mn-header-link', {
                module1: '产品帮助',
                module2: item.title,
              })
            }}
          >
            <Icon type={item.icon} className="item-icon" />
          </div>
        </Tooltip>
      })}
    </div>
    {feedbackVisible ? <Feedback visible={feedbackVisible} onClose={() => setFeedbackVisible(false)} /> : null}
  </div>
}
